<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-card :loading="loading">
        <v-card-title class="text-subtitle-2">
          {{ $t('common.user_details') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-alert
            v-if="isLocked"
            outlined
            type="error"
            prominent
          >
            <v-row align="center">
              <v-col class="grow">
                {{ $t('auth.locked_warning') }}
              </v-col>
              <v-col class="shrink">
                <v-btn
                  color="error"
                  @click="unlockUser()"
                >
                  {{ $t('auth.locked_button') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-form
            ref="profile"
            @submit.prevent="saveProfile()"
          >
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="person"
                  name="first_name"
                  :label="$t('common.first_name')"
                  :rules="rules.first_name"
                  validate-on-blur
                  :error-messages="errors.first_name"
                  v-model="userData.first_name"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="person"
                  name="last_name"
                  :label="$t('common.last_name')"
                  :rules="rules.last_name"
                  validate-on-blur
                  :error-messages="errors.last_name"
                  v-model="userData.last_name"
                />
              </v-col>
              <!--              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  prepend-icon="mdi-table"
                  name="view"
                  :items="views"
                  :label="$t('common.default_view')"
                  :rules="rules.view"
                  validate-on-blur
                  :error-messages="errors.view"
                  v-model="userData.view"
                />
              </v-col>-->
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  prepend-icon="mdi-account-arrow-left"
                  name="auth_expiry"
                  :items="expiries"
                  :label="$t('auth.auto_logout')"
                  :rules="rules.auth_expiry"
                  validate-on-blur
                  :error-messages="errors.auth_expiry"
                  v-model="userData.auth_expiry"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  prepend-icon="mdi-map"
                  name="language"
                  :items="languages"
                  :label="$t('common.language')"
                  :rules="rules.language"
                  validate-on-blur
                  :error-messages="errors.language"
                  v-model="userData.language"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  prepend-icon="mdi-calendar"
                  name="date_format"
                  :items="dateFormats"
                  :label="$t('common.date_format')"
                  :rules="rules.date_format"
                  validate-on-blur
                  :error-messages="errors.date_format"
                  v-model="userData.date_format"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="person"
                  name="email"
                  :label="$t('common.email_address')"
                  :value="userData.email"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="mdi-cellphone"
                  name="sms_email"
                  type="email"
                  :label="$t('common.sms_email')"
                  :rules="rules.sms_email"
                  validate-on-blur
                  :error-messages="errors.sms_email"
                  v-model="userData.sms_email"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="mdi-phone"
                  name="phone_primary"
                  type="phone"
                  :label="$t('common.phone')"
                  :rules="rules.phone_primary"
                  validate-on-blur
                  :error-messages="errors.phone_primary"
                  v-model="userData.phone_primary"
                />
              </v-col>
              <v-col
                v-if="false"
                class="hidden"
                cols="12"
              >
                <time-slot-selector
                  :label="$t('common.hardwear_notifications_timeslots')"
                  v-model="userData.heartbeat_timeslots"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-switch
                  v-model="userData.heartbeat"
                  :label="$t('common.heartbeat_notifications')"
                />
              </v-col>
              <v-col
                v-if="false"
                class="hidden"
                cols="12"
                sm="6"
              >
                <v-switch
                  v-model="userData.hardwear_events"
                  :label="$t('common.hardwear_notifications')"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-select
                  :readonly="!administrator"
                  :value="userData.groups.filter(({ pivot }) => pivot.can).map(({ id }) => id)"
                  item-text="name"
                  item-value="id"
                  :items="allGroups"
                  :label="$t('common.groups')"
                  multiple
                  chips
                  deletable-chips
                  @change="updateEnabledGroups"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
                v-if="!administrator"
              >
                <v-alert
                  type="info"
                  color="primary accent-4"
                  elevation="2"
                  border="left"
                  prominent
                  light
                  dense
                >
                  <v-card-text
                    class="text-subtitle-1 strong"
                  >
                    {{ this.$t('permission.user_permissions') }}
                  </v-card-text>
                </v-alert>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <span class="subtitle-1">
                  {{ $t('common.permissions') }}
                </span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-switch
                  v-model="userData.administrator"
                  :disabled="!canRemoveAdmin()"
                  :true-value="true"
                  :false-value="false"
                  :label="$t('common.isAdmin')"
                />
              </v-col>
            </v-row>
            <v-row v-if="user.id !== userId || !administrator">
              <v-col
                v-for="permission in permissions.filter(p => (p.name !== 'users') && (p.name !== 'tasks'))"
                :key="permission.id"
                cols="6"
                sm="4"
              >
                <v-switch
                  :disabled="!administrator"
                  :input-value="!!userData.permissions.find(p => p.id === permission.id)"
                  :true-value="true"
                  :false-value="false"
                  :label="permission.name"
                  @change="setPermission($event, permission.id)"
                />
              </v-col>
            </v-row>
            <v-card-actions>
              <v-dialog
                v-if="can('users') && userId !== user.id"
                v-model="deleteUserModal"
                width="500"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $t('auth.deactivate') }}
                  </v-btn>
                </template>
                <v-card
                  :loading="loading"
                >
                  <v-card-title>
                    {{ $t('auth.deactivate_title') }}
                  </v-card-title>
                  <v-card-text>
                    {{ $t('auth.deactivate_message') }}
                  </v-card-text>
                  <v-divider />
                  <v-card-actions>
                    <v-btn
                      text
                      @click="deleteUserModal = false"
                    >
                      {{ $t('common.cancel') }}
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="error"
                      dark
                      @click="deleteUser()"
                    >
                      {{ $t('auth.deactivate') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn
                v-if="userSwitchingEnabled && administrator && userId !== user.id"
                :href="`${app.url}/switch/${userId}`"
                class="ml-2"
              >
                {{ $t('auth.switch') }}
              </v-btn>
              <v-spacer />
              <v-btn
                type="submit"
                color="primary"
                :disabled="loading"
              >
                {{ $t('common.save') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import url from '../../../utils/url';
import { ruleRequired, ruleInArray, ruleEmail } from '../../../utils/rules';
import TimeSlotSelector from '../../elements/time-slot-selector.vue';

export default {
  name: 'UserDetails',
  components: {
    TimeSlotSelector,
  },
  props: {
    accountName: {
      type: String,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userSwitchingEnabled: false, // Disable user switching for non-Setra admins (Requested 01/02/2022)
      loading: true,
      userData: {
        groups: [],
      },
      expires_at: null,
      errors: {
        first_name: [],
        last_name: [],
        view: [],
        language: [],
        auth_expiry: [],
        sms_email: [],
        phone_primary: [],
      },
      deleteUserModal: false,
      permissions: [],
      allGroups: [],
      modifiedGroups: [],
    };
  },
  computed: {
    ...mapGetters(['user', 'config', 'formatDate', 'can', 'app', 'languages', 'dateFormats', 'views', 'administrator']),
    profileUrl() {
      return url`/api/v1/accounts/${this.accountName}/users/${this.userId}`;
    },
    groupsUrl() {
      return url`/api/v1/accounts/${this.accountName}/groups?withDisabled=false&perPage=999999`;
    },
    expiries() {
      const minutes = this.config.expiry_minutes;
      return minutes.map(value => ({
        text: this.$t('common.minutes_unit', { value }),
        value,
      }));
    },
    rules() {
      return {
        first_name: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.first_name') })),
        ],
        last_name: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.last_name') })),
        ],
        view: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.default_view') })),
          ruleInArray(this.views, this.$t('validation.in', { attribute: this.$t('common.default_view') })),
        ],
        language: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.language') })),
        ],
        auth_expiry: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('auth.auto_logout') })),
          ruleInArray(this.config.expiry_minutes, this.$t('validation.in', { attribute: this.$t('auth.auto_logout') })),
        ],
        sms_email: [
          ruleEmail(this.$t('validation.email', { attribute: this.$t('common.sms_email') })),
        ],
        phone_primary: [],
        date_format: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.date_format') })),
          ruleInArray(this.config.date_formats, this.$t('validation.in', { attribute: this.$t('common.date_format') })),
        ],
      };
    },
    isLocked() {
      if (this.user.id === this.userData.id || !this.can('users')) return false;
      return this.userData.login_attempts >= this.config.auth.max_attempts;
    },
    languages() {
      return this.$store.getters.languagesDisplay;
    },
  },
  async created() {
    try {
      const [user, perms, groups] = await Promise.all([
        this.http.get(this.profileUrl),
        this.http.get(url`/api/v1/permissions`),
        this.http.get(this.groupsUrl),
      ]);
      this.userData = user.data.user;
      this.permissions = perms.data.permissions;
      this.allGroups = groups.data.data;
      this.expires_at = user.data.expires_at;
    } catch (e) {
      this.error(e);
    } finally {
      this.loading = false;
      this.canRemoveAdmin();
    }
  },
  methods: {
    ...mapActions(['success', 'error']),
    ...mapMutations(['setUser']),
    resetErrors() {
      Object.keys(this.errors).forEach(field => {
        this.errors[field] = [];
      });
    },
    updateEnabledGroups(value) {
      // Conditional array used to check if we should be adding groups
      const conditionalArr = [];
      // groupsToRemove array to check if we should be removing groups
      let groupsToRemove = [];
      // User Data Group ID's
      let userDataIDs = [];

      // Check if the value in userData.groups already exists?
      const exists = this.userData.groups.filter(g => value.includes(g.id));
      // If the exists array is not empty
      if (typeof exists !== 'undefined' || exists.length > 0) {
        exists.forEach(g => {
          // Push the existing ID's into an array
          conditionalArr.push(g.id);
        });
      }

      // Loop through the selected array of values to push only the required groups to the userData.groups array (this stops duplications)
      value.forEach(v => {
        if (conditionalArr.includes(v)) {
          // Ignore any groups that existed previously in userData.groups
          return;
        }
        // Find teh group in allGroups that match the ID ( v ) passed through
        const validGroup = this.allGroups.find(g => g.id === v);
        // Before pushing, check if we're removing any groups
        this.userData.groups.push(validGroup);
      });

      // Get the ID's of the existing groups in the userData.groups array
      this.userData.groups.forEach(g => {
        userDataIDs.push(g.id);
      });

      // Evaluate if we should be removing any groups from the userData.groups array
      groupsToRemove = userDataIDs.filter(g => !value.includes(g));

      // If there are any groups to remove
      if (groupsToRemove.length > 0) {
        // Foreach group to remove...
        groupsToRemove.forEach(i => {
          // Find the index for the group to be removed from the userData.groups array
          const r = this.userData.groups.findIndex(item => item.id === i);
          // Remove the selected group
          this.userData.groups.splice(r, 1);
        });
      }

      userDataIDs = [];
      this.userData.groups.forEach(g => {
        userDataIDs.push(g.id);
      });

      // Finally
      this.modifiedGroups = userDataIDs;
    },
    setPermission(checked, permId) {
      if (checked) {
        this.userData.permissions.push({ id: permId });
      } else {
        this.userData.permissions = this.userData.permissions.filter(({ id }) => id !== permId);
      }
    },
    async saveProfile() {
      if (this.loading) return; // Prevent multiple submissions which can empty alarm_groups
      if (!this.$refs.profile.validate()) return;

      try {
        this.loading = true;
        this.resetErrors();
        if (this.$route.name !== 'account.users.create') {
          // Here we check if the array exists and is not empty, this would indicate the user has changed their alarm groups and we have a modifiedGroups array to use.
          if (this.modifiedGroups !== undefined && this.modifiedGroups.length > 0) {
            // If the modifiedGroups array is not empty, we can assume the user has changed their alarm groups and we can use the modifiedGroups array.
            this.userData.groups = this.modifiedGroups;
          } else {
            // If the modifiedGroups array is empty, we can assume the user has not changed their alarm groups and we can use the existing userData.groups array.
            // We do need map this to Ids as when
            // it's returned fresh it's an array of objects.
            this.userData.groups = this.userData.groups.map(({ id }) => id);
          }
        }
        const {
          first_name,
          last_name,
          view,
          language,
          auth_expiry,
          sms_email,
          phone_primary,
          heartbeat,
          heartbeat_timeslots,
          hardwear_events,
          date_format,
          groups,
          permissions,
          administrator,
        } = this.userData;
        const { status, data } = await this.http.post(this.profileUrl, {
          first_name,
          last_name,
          view,
          language,
          auth_expiry,
          sms_email,
          phone_primary,
          heartbeat,
          heartbeat_timeslots,
          hardwear_events,
          date_format,
          groups,
          permissions,
          administrator,
        });

        if (status === 200) {
          this.userData = data.user;
          this.success(this.$t('common.saved'));
          if (this.userData.id === this.user.id) {
            // Copy the initial data as the profile screen wont load possible relations.
            const user = { ...this.user };
            Object.keys(data.user).forEach(property => {
              user[property] = data.user[property];
            });
            this.setUser(user);
          }
          return;
        }

        throw new Error('Error Saving Profile!');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          const { errors = {} } = e.response.data;
          Object.keys(this.errors).forEach(field => {
            this.errors[field] = errors[field] || [];
          });
          return;
        }
        this.error(e);
      } finally {
        this.loading = false;
      }
    },
    async unlockUser() {
      try {
        this.loading = true;
        const { status, data } = await this.http.post(this.profileUrl, { login_attempts: 0 });

        if (status === 200) {
          this.userData = data.user;
          this.success(this.$t('auth.unlocked'));
          if (this.userData.id === this.user.id) {
            // Copy the initial data as the profile screen wont load possible relations.
            const user = { ...this.user };
            Object.keys(data.user).forEach(property => {
              user[property] = data.user[property];
            });
            this.setUser(user);
          }
          return;
        }

        throw new Error('Error Unlocking User!');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          const { errors = {} } = e.response.data;
          Object.keys(this.errors).forEach(field => {
            this.errors[field] = errors[field] || [];
          });
          return;
        }
        this.error(e);
      } finally {
        this.loading = false;
      }
    },
    async deleteUser() {
      try {
        this.loading = true;
        const { status } = await this.http.delete(this.profileUrl);

        if (status === 200) {
          this.success(this.$t('auth.deactivated'));
          await this.$router.push({ name: 'account.users', params: { accountName: this.accountName } });
          return;
        }

        throw new Error('Error Deactivating User!');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          const { errors = {} } = e.response.data;
          Object.keys(this.errors).forEach(field => {
            this.errors[field] = errors[field] || [];
          });
          return;
        }
        this.error(e);
      } finally {
        this.loading = false;
        this.deleteUserModal = false;
      }
    },
    /**
     * Methods: canRemoveAdmin
     * Evaluates
     *
     * @returns {boolean}
     */
    canRemoveAdmin() {
      return (this.userId !== this.user.id);
    },
  },
};
</script>

<style scoped>
  .hidden {
    opacity: 0;
    display: none;
  }
</style>
